import { customersApiClient } from './apiClient';

export const feedbackService = {
  async getTripFeedback(tripId) {
    const result = await customersApiClient.get(`/trips/${tripId}/feedback`);

    if (!result.success) {
      return {
        success: false,
        feedback: null,
        error: result.error || 'Failed to fetch trip feedback',
      };
    }

    // Shape per api-docs/ratings-feedback-issues-api.md:
    // { by_driver: {rating, feedback}, by_passenger: {rating, feedback} }
    // (unset sides come back with null rating/feedback).
    return {
      success: true,
      feedback: result.data?.feedback || null,
      error: null,
    };
  },

  async getQuestions() {
    const result = await customersApiClient.get('/feedback/questions');

    if (!result.success) {
      return {
        success: false,
        questions: [],
        error: result.error || 'Failed to fetch feedback questions',
      };
    }

    return {
      success: true,
      questions: result.data?.questions || [],
      error: null,
    };
  },

  // Contract (ratings-feedback-issues-api.md): at least one of rating (1-5) /
  // feedback (string ≤2000). Each is set-once per role — resubmitting → 400.
  async submitTripFeedback(tripId, { rating, feedback }) {
    const payload = {};
    if (rating != null) payload.rating = rating;
    if (feedback) payload.feedback = feedback;

    const result = await customersApiClient.post(`/trips/${tripId}/feedback`, payload);

    if (!result.success) {
      return {
        success: false,
        data: null,
        error: result.error || 'Failed to submit feedback',
        raw: result.raw,
      };
    }

    return {
      success: true,
      data: result.data,
      error: null,
    };
  },
};

export default feedbackService;
